// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Rv9x","col":"styles_col__Hs3GX","fulfillmentStatus":"styles_fulfillmentStatus__34t4S","emailCol":"styles_emailCol__2hcwX"};